var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownarrowfill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.794,
    height: 6.168,
    viewBox: "0 0 10.794 6.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11233",
    "data-name": "Path 11233",
    d: "M64.937,237.549H55.493a.643.643,0,0,0-.474.2.68.68,0,0,0,0,.964l4.722,4.8a.655.655,0,0,0,.949,0l4.722-4.8a.68.68,0,0,0,0-.964A.643.643,0,0,0,64.937,237.549Z",
    transform: "translate(-54.818 -237.549)",
    fill: "#156ae6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrowfill);
export default __webpack_public_path__ + "static/media/downarrowfill.5e913aab482527c1520cbc6c697074ec.svg";
export { ForwardRef as ReactComponent };